import React from "react";
import { Typography, CardContent, Button } from "@mui/material";
import { AppCard } from "../components";

export function ComponentGallery() {
    return (
        <div className="p-8 space-y-8">
            <Typography variant="h4" className="font-bold text-gray-800">
                Component Gallery
            </Typography>

            {/* --- AppCard Showcase --- */}
            <section>
                <Typography variant="h6" className="mb-4 text-gray-700">
                    AppCard
                </Typography>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <AppCard className="p-6">
                        <CardContent>
                            <Typography variant="h6" className="font-semibold text-gray-800">
                                Default Card
                            </Typography>
                            <p className="mt-2 text-gray-600">
                                This is the base card with Tailwind + MUI styling.
                            </p>
                        </CardContent>
                    </AppCard>
                </div>
            </section>

            {/* --- Add more components here --- */}
            <section>
                <Typography variant="h6" className="mb-4 text-gray-700">
                    Buttons
                </Typography>
                <div className="flex gap-4">
                    <Button variant="contained" color="primary">
                        Primary
                    </Button>
                    <Button variant="outlined" color="secondary">
                        Secondary
                    </Button>
                    <Button variant="text" color="error">
                        Danger
                    </Button>
                </div>
            </section>
        </div>
    );
};
